import { useState } from "react";
import Toast from "@/components/base/Toast";
import { navLinks, siteBrand } from "@/mocks/home";

export default function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [toast, setToast] = useState<string | null>(null);

  const handleSubscribe = () => {
    setToast("已为你开启头条提醒（演示效果，不会真实推送）");
    window.setTimeout(() => setToast(null), 2400);
  };

  return (
    <>
      <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="w-full border-b border-background-200/70 bg-accent-50">
          <div className="flex items-center justify-between gap-4 px-4 py-1.5 md:px-8">
            <p className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-600">
              <i className="ri-calendar-line text-accent-700" />
              <span>{siteBrand.today}</span>
              <span className="hidden text-background-400 sm:inline">|</span>
              <span className="hidden sm:inline">{siteBrand.tagline}</span>
            </p>
            <p className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-600">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-pulse rounded-full bg-primary-500 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
              </span>
              {siteBrand.updateTime}
            </p>
          </div>
        </div>

        <div className="flex h-16 items-center justify-between gap-3 px-4 md:px-8">
          <a href="#focus" className="flex shrink-0 cursor-pointer items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-line text-lg" />
            </span>
            <h1 className="font-heading text-2xl leading-none tracking-wide text-foreground-950">
              {siteBrand.name}
            </h1>
          </a>

          <nav className="hidden items-center gap-0.5 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="cursor-pointer whitespace-nowrap rounded-full px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <div className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 md:flex">
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                type="text"
                placeholder="搜索爆料关键词"
                className="w-28 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400 xl:w-44"
              />
            </div>
            <button
              type="button"
              onClick={handleSubscribe}
              className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              <i className="ri-notification-3-line" />
              订阅推送
            </button>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="animate-fade-in border-t border-background-200 bg-background-50 px-4 py-3 md:px-8 lg:hidden">
            <nav className="grid grid-cols-2 gap-1.5">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-secondary-100"
                >
                  {link.label}
                </a>
              ))}
            </nav>
            <div className="mt-3 flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                type="text"
                placeholder="搜索爆料关键词"
                className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="button"
              onClick={handleSubscribe}
              className="mt-3 flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-notification-3-line" />
              订阅头条推送
            </button>
          </div>
        )}
      </header>
      <Toast message={toast} />
    </>
  );
}